'use client'

import Image from 'next/image'

import { Button, Separator } from '@/components/ui'
import { SUPPORT_EMAIL } from '@/utils/constants'
import type { DataRenderTemplate } from '@/utils/renderTemplate'
import { sanitizeHTML } from '@/utils/sanitize'

type TemplateEmailProps = {
  emailData: DataRenderTemplate
}

export function TemplateEmail({ emailData }: TemplateEmailProps) {
  const { title, greeting, bodyMessage, link } = emailData

  return (
    <div className="relative flex w-full flex-col items-center rounded-lg bg-white">
      <div
        className="pointer-events-auto absolute inset-0 z-10 cursor-not-allowed rounded-lg bg-black/10"
        aria-hidden="true"
      />

      <div className="pointer-events-none relative flex w-full flex-col items-center">
        <div className="flex w-full flex-col items-center gap-2.5 py-5">
          <div className="flex flex-col items-center gap-1">
            <Image
              src="/assets/avantti-purple.png"
              alt="Avantt.i"
              width={100}
              height={100}
              className="object-contain"
            />
          </div>
          {title && (
            <h1 className="mt-5 text-center text-xl font-semibold text-system-text-primary">
              {title}
            </h1>
          )}
          <Separator />
        </div>

        <div className="flex w-full flex-col gap-4 px-5 pb-5">
          {greeting && (
            <p className="text-base leading-relaxed text-system-text-primary">
              {greeting}
            </p>
          )}

          {bodyMessage && (
            <div
              className="prose prose-sm *: max-w-none text-base leading-relaxed text-system-text-primary [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:text-xl [&_h2]:font-semibold [&_ol]:list-decimal [&_ol]:pl-4 [&_p]:mb-3 [&_p]:last:mb-0 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-4"
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(bodyMessage ?? ''),
              }}
            />
          )}

          {link && (
            <div className="pointer-events-none">
              <Button
                className="flex items-center justify-center"
                asChild
                variant="slate"
                disabled
              >
                <span className="w-full p-0 text-center ">
                  {link || 'Clique aqui para acessar'}
                </span>
              </Button>
            </div>
          )}
        </div>

        <div className="w-full border-t border-system-border-secondary bg-system-background-grey p-5 text-center">
          <p className="text-sm leading-relaxed text-system-text-secondary">
            Está com problemas? Entre em contato com nosso suporte{' '}
            <span className="text-system-primary-purple no-underline">
              {SUPPORT_EMAIL}
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}
